var Search = {
    init: function () {
        $( ".submit--search" ).on( "click touchend", function(e){
            e.preventDefault();
            if(e.type == "touchend"){
                $(this).off("click");
            }
            Debug.log('Submit search');
            $(".search--form").submit();
        });
        $('#search').on('input', function (){
            if($('#search').val().length >= 3){
                $(".search--form").trigger('submit');
            }
        });
        $(".search--form").on('submit', function(e){
            e.preventDefault();
            dataForm = {
                action: 'search_product',
                search: $('#search').val()
            }
            $.ajax({
                type: 'post',
                url: woocommerce_params.ajax_url,
                data: dataForm,
                beforeSend:function(){
                  $(".search--form").find('.form-item').addClass('active');
                },
                success: function(response) {
                    data = JSON.parse(response);
                    Debug.log(data);
                    $(".search--form").find('.form-item').removeClass('active');
                    if(data.product_grid){
                        $(".no-results").removeClass("visible");
                        $('.results .list-results').html(data.product_grid);
                    }else{
                        $('.results .list-results').html("");
                        $(".no-results").addClass("visible");
                    }
                },
            });
        });
    },
};
$(window).load(function(){
    if($(".search--form").length){
        Search.init();
    }
});

